import logsnag from "./logsnag";
import console from "./console";

export default process.env.NEXT_PUBLIC_LOGSNAG_KEY
  ? logsnag(process.env.NEXT_PUBLIC_LOGSNAG_KEY as string)
  : console();
